import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";

// Mobile "Sheet" equivalent: bottom sheet on small screens, centered dialog on tablet/desktop.
export function Sheet({ visible, onClose, title, children, testID }) {
  return (
    <Dialog.Root open={visible} onOpenChange={(o) => !o && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay data-testid={`${testID}-backdrop`} className="fixed inset-0 z-50 bg-black/60 backdrop-blur-[2px] data-[state=open]:animate-in data-[state=open]:fade-in-0" />
        <Dialog.Content
          data-testid={testID}
          aria-describedby={undefined}
          className="fixed inset-x-0 bottom-0 z-50 flex max-h-[90vh] flex-col rounded-t-[20px] border-t border-[#333333] bg-[#1E1E1E] p-4 pb-6 shadow-2xl outline-none data-[state=open]:animate-in data-[state=open]:slide-in-from-bottom-8 md:inset-x-auto md:bottom-auto md:left-1/2 md:top-1/2 md:w-[560px] md:-translate-x-1/2 md:-translate-y-1/2 md:rounded-[20px] md:border md:p-6 md:data-[state=open]:zoom-in-95 md:data-[state=open]:slide-in-from-bottom-0"
        >
          <div className="mx-auto mb-3 h-1 w-10 rounded bg-[#555555] md:hidden" />
          <div className="mb-4 flex items-center">
            <Dialog.Title className="t-h2 flex-1 font-display !font-normal">{title}</Dialog.Title>
            <Dialog.Close
              data-testid={`${testID}-close`}
              aria-label="Fermer"
              className="focus-ring flex h-11 w-11 items-center justify-center rounded-full border border-[#333333] bg-[#1E1E1E] text-white hover:text-[#D4AF37]"
            >
              <X className="h-[22px] w-[22px]" />
            </Dialog.Close>
          </div>
          <div className="-mx-1 overflow-y-auto px-1">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
